import type { FaireProductEntity } from "../../entity_types/product";

export const p_dtubmvrs4w: FaireProductEntity = {
  token: "p_dtubmvrs4w",
  type: "product",
  name: "Enamel Evil Eye Round Coin Shape Gold-Filled Dangle Earrings",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/9b80a739576cd65d24b855587ed715653ef76ed4ac077aa4d45f6cbc4b36814b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/045449abe5fbbaae0c0895d10d084368b8649462d8ce03ac1b38d9a0cb5a8655.jpeg",
    "https://cdn.faire.com/fastly/8c45278fd65cacbf312269d3503311cc7104bad159e77ba4650dd06f0f1f243c.jpeg",
    "https://cdn.faire.com/fastly/e892fe831231a7da80aa3e20b7d9b0306adfc14d23f9b0e832b0757d5e1307c8.jpeg",
  ],
  priceDollars: 11.07,
  description:
    "Qty:1pc pack\nMaterial: Brass and Cubic Zirconia and Enamel, Gold Filled\nSize: 33x18mm\n\n",
  tags: [],
  msrpDollars: 22.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:52.082Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
